import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from './LanguageSwitcher';

export function BankIdLayout({ children, below, wide = false }: { children: React.ReactNode; below?: React.ReactNode; wide?: boolean }) {
  const { t } = useTranslation();
  return <main className="bankid-layout min-vh-100 d-flex flex-column p-3 p-sm-4">
    <div className="d-flex justify-content-end mb-3"><LanguageSwitcher /></div>
    <div className={`bankid-card mx-auto bg-white border rounded-4 p-4 p-sm-5 ${wide ? 'bankid-card-wide' : ''}`}>
      <Link to="/" className="d-block text-center mb-4"><img src="/assets/images/logo-full.png" alt="ETAPPIO" width="180" className="img-fluid" /></Link>
      {children}
    </div>
    <div className="text-center my-3">{below}<a className="d-block py-3" href="mailto:support@etappio.se">{t('auth.bankid.support')}</a></div>
    <footer className="mt-auto d-flex flex-wrap justify-content-center gap-3 pt-4 small">
      <Link className="py-3" to="/anvandarvillkor">{t('auth.bankid.terms')}</Link>
      <Link className="py-3" to="/integritet">{t('auth.bankid.privacy')}</Link>
      <Link className="py-3" to="/kontakt">{t('auth.bankid.contact')}</Link>
    </footer>
  </main>;
}

export function RegistrationSteps({ currentStep, companyAfterEmail = false }: { currentStep: number; companyAfterEmail?: boolean }) {
  const { t } = useTranslation();
  return <ol className="bankid-steps list-unstyled d-flex justify-content-between gap-1 mb-4" aria-label={t('onboarding.title')}>
    {(companyAfterEmail ? ['bankid', 'profile', 'terms', 'email', 'company', 'complete'] : ['bankid', 'profile', 'terms', 'email', 'complete']).map((step, index) => <li key={step} className={`text-center flex-fill ${index === currentStep ? 'text-primary fw-bold' : 'text-muted'}`} aria-current={index === currentStep ? 'step' : undefined}>
      <span className={`bankid-step-number d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2 ${index <= currentStep ? 'bg-primary text-white' : 'border'}`} aria-hidden="true">{index < currentStep ? <i className="bi bi-check-lg" /> : index + 1}</span>
      <span>{t(`onboarding.steps.${step}`)}</span>
    </li>)}
  </ol>;
}
